import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, uniqBy } from 'lodash';

import { Fields } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import DiagnosesAddDialog from 'components/patient/PatientProfile/Diagnoses/DiagnosesAddDialog';
import MultiselectAutosuggestField from 'components/fields/MultiselectAutosuggestField';

import { changePatientResource } from 'redux/modules/patients';

const styles = () => ({
  root: {
    marginTop: 10,
  },
  gridItemDxCode: {
    width: 64,
  },
});

class ProductClaimDiagnosisFields extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addDialogOpen: false,
    };

    this.onAddButtonClick = this.onAddButtonClick.bind(this);
    this.onAddDialogClose = this.onAddDialogClose.bind(this);
  }

  onAddButtonClick() {
    this.setState({ addDialogOpen: true });
  }

  onAddDialogClose() {
    this.setState({ addDialogOpen: false });
  }

  render() {
    const {
      name,
      onFieldFocus,
      onFieldBlur,
      Diagnosis,
      Patient,
      actions,
      formValues,
      disabled,
      classes,
      ...fields
    } = this.props;
    const { addDialogOpen } = this.state;
    const diagnosis = get(fields, `${name}.Diagnosis`);
    const diagnosisID = get(fields, 'Diagnosis ID');
    const allDiagnosis = Diagnosis && Diagnosis.length >= 12
      ? Diagnosis
      : uniqBy([
        ...Patient.Diagnosis || [],
        ...Diagnosis || [],
      ], 'ID');
    const leftOrderDiagnosis = diagnosis.input.value && typeof diagnosis.input.value === 'object'
      ? allDiagnosis.filter(item =>
        diagnosis.input.value.filter(diagnosisItem => diagnosisItem.value === item.ID).length === 0)
      : [];
    return (
      <Fragment>
        <Fields
          id="Diagnosis"
          label="Diagnosis"
          names={[
            `${name}.diagnosisName`,
            `${name}.Diagnosis`,
          ]}
          autosuggestFieldName={`${name}.diagnosisName`}
          fieldArrayName={`${name}.Diagnosis`}
          placeholder="-Select Diagnosis-"
          errorPlacement="top"
          maxArrayLength={4}
          component={MultiselectAutosuggestField}
          labelOverlap
          noWrap
          renderSuggestionContent={suggestion => (
            <Grid container spacing={8} wrap="nowrap">
              <Grid item className={classes.gridItemDxCode}>
                {suggestion['DX Code']}
              </Grid>
              <Grid item xs={10}>
                {suggestion['Long Description']}
              </Grid>
            </Grid>
          )}
          renderInputContent={suggestion => suggestion['DX Code']}
          onSuggestionSelected={(suggestion) => {
            let diagnosisIndex = diagnosisID.input.value.indexOf(suggestion.ID);
            if (!diagnosisID.input.value
              || diagnosisIndex === -1) {
              diagnosisID.input.onChange([
                ...diagnosisID.input.value || [],
                suggestion.ID,
              ]);
            }
            if (!diagnosis.input.value
              || diagnosis.input.value.filter(item => item.value === suggestion.ID).length === 0) {
              diagnosisIndex = diagnosisIndex === -1
                ? diagnosisID.input.value.length : diagnosisIndex;
              const diagnosisPointer = 'ABCDEFGHIJKL'.slice(diagnosisIndex, diagnosisIndex + 1);
              diagnosis.input.onChange([
                ...diagnosis.input.value || [],
                {
                  value: suggestion.ID,
                  label: diagnosisPointer,
                },
              ]);
            }
            return '';
          }}
          fetchSuggestions={({ value, offset }) => (
            new Promise((resolve) => {
              if (offset === 0) {
                if (value.length >= 2 && /^[A-Z]+\d/i.test(value)) {
                  resolve(leftOrderDiagnosis
                    .filter(item => item['DX Code'].toLowerCase().indexOf(value.toLowerCase()) === 0));
                } else if (value.length > 0) {
                  resolve(leftOrderDiagnosis
                    .filter(item => item['Long Description'].toLowerCase().indexOf(value.toLowerCase()) !== -1));
                } else {
                  resolve(leftOrderDiagnosis);
                }
              } else {
                resolve([]);
              }
            })
          )}
          firstHighlighted
          draggable
          onListAdornmentClick={this.onAddButtonClick}
          listAdornmentText="Add From List"
          listAdornmentButtonDisabled={Diagnosis && Diagnosis.length >= 12}
          disabled={disabled}
        />
        <DiagnosesAddDialog
          open={addDialogOpen}
          onClose={this.onAddDialogClose}
          onSubmitSuccess={(values) => {
            this.onAddDialogClose();
            new Promise((resolve, reject) => {
              actions.changePatientResource({
                'Record Number': Patient['Record Number'],
                'Diagnosis ID': [
                  ...Patient.Diagnosis.map(item => item.ID),
                  values.ID,
                ],
                resolve,
                reject,
              });
            }).then(() => {
              if (!diagnosisID.input.value || diagnosisID.input.value.indexOf(values.ID) === -1) {
                diagnosisID.input.onChange([
                  ...diagnosisID.input.value || [],
                  values.ID,
                ]);
                const diagnosisIndex = diagnosisID.input.value ? diagnosisID.input.value.length : 0;
                const diagnosisPointer = 'ABCDEFGHIJKL'.slice(diagnosisIndex, diagnosisIndex + 1);
                diagnosis.input.onChange([
                  ...diagnosis.input.value || [],
                  {
                    value: values.ID,
                    label: `${diagnosisPointer}: ${values['DX Code']}`,
                  },
                ]);
              }
            });
          }}
          formValues={formValues}
        />
      </Fragment>
    );
  }
}

ProductClaimDiagnosisFields.propTypes = {
  name: PropTypes.string.isRequired,
  onFieldFocus: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  Diagnosis: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  Patient: PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    changePatientResource: PropTypes.func.isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    gridItemDxCode: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimDiagnosisFields.defaultProps = {
  formValues: {},
  disabled: false,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ changePatientResource }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(ProductClaimDiagnosisFields),
);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimDiagnosisFields.js